import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '@/redux/store'
import { ReferralCollectionItem } from '@/types/responses/referrals'

const INITIAL_STATE: ReferralsState = {
  selectedReferrals: [],
}

interface ReferralsState {
  selectedReferrals: ReferralCollectionItem[]
}

const referrals = createSlice({
  name: 'referrals',
  initialState: INITIAL_STATE,
  reducers: {
    toggleReferralSelection(
      state,
      action: PayloadAction<ReferralCollectionItem>,
    ) {
      const selectedReferrals = state.selectedReferrals
      const toggledReferral = action.payload

      const isAlreadySelected = selectedReferrals.some(
        (referral) => referral.id === toggledReferral.id,
      )

      // Remove referral from selected referrals if it's already selected
      if (isAlreadySelected) {
        state.selectedReferrals = selectedReferrals.filter(
          (referral) => referral.id !== toggledReferral.id,
        )
      }
      // Add referral to selected referrals if it's not already selected
      else {
        state.selectedReferrals = [...selectedReferrals, toggledReferral]
      }
    },

    removeSelectedReferrals(state, action: PayloadAction<IRI[]>) {
      const irisToRemove = action.payload

      state.selectedReferrals = state.selectedReferrals.filter(
        (referral) => !irisToRemove.includes(referral['@id']),
      )
    },

    clearSelectedReferrals(state) {
      state.selectedReferrals = []
    },
  },
})

export const selectReferrals = (state: RootState) => state.referrals

export const selectSelectedReferrals = createSelector(
  selectReferrals,
  (referrals) => referrals.selectedReferrals,
)

export const selectHasSelectedReferral = createSelector(
  selectSelectedReferrals,
  (selectedReferrals) => selectedReferrals.length > 0,
)

export const {
  toggleReferralSelection,
  removeSelectedReferrals,
  clearSelectedReferrals,
} = referrals.actions

export const referralsReducer = referrals.reducer

export function isReferralSelected(
  selectedReferrals: ReferralsState['selectedReferrals'],
  referral: ReferralCollectionItem,
) {
  return selectedReferrals.some(
    (selectedReferral) => selectedReferral.id === referral.id,
  )
}
